import { cn } from "@/lib/utils";
import { type HTMLAttributes } from "react";

type AccentTextProps = HTMLAttributes<HTMLSpanElement> & {
  children: React.ReactNode;
};

export const accentTextStyles =
  'text-secondary -mx-1 bg-[url("/images/home/number-accent.svg")] bg-[length:100%_auto] bg-bottom bg-no-repeat px-1 pb-1.5 font-medium';

export const AccentText = ({
  children,
  className,
  ...props
}: AccentTextProps) => {
  return (
    <span className={cn(accentTextStyles, className)} {...props}>
      {children}
    </span>
  );
};
